<template>
   <div class="visit-card">
    <label for="files" class="btn"
    >+{{$_('add_visit_card')}} ({{nNbFichier}} {{$_('files')}})</label>
    <input type="file" id="files" ref="visitcard" v-on:change="handleFileUpload()" multiple />
  </div>
</template>

<script>
export default {
  name: 'FormAttachment',
  data() {
    return {
      nNbFichier: 0,
      visitcard: Array()
    }
  },
  methods: {
    handleFileUpload() {
      this.$store.dispatch('echantillon/SET', {key: 'form_attachment', value: this.$refs.visitcard.files});
      this.nNbFichier = this.$refs.visitcard.files.length
    },
  }
}
</script>

<style scoped>
input[type="file"] {
  visibility:hidden;
}
</style>